// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"9f892290","912":"749bb3fb"}[chunkId] + ".chunk.css";
};